module.exports = __webpack_public_path__ + "static/media/strengthbannernew2.0b99550f.png";